module.exports = __webpack_public_path__ + "img/cb2-l-y1.47e99c71.gif";